<template>
    <div>
        <div class="row" v-if="infoData">
            <div class="col-sm-8">
                {{ $t('ADDITIONAL_MEDICAL_DATA_INFO') }}
                <br /><br />
                <p v-if="tableData1.length">
                    {{ $t('ADDITIONAL_MEDICAL_DATA_NUMBER') }} <strong>{{ tableData1.length }}</strong>
                </p>
                <p v-else>{{ $t('YOU_DONT_HAVE_MEDICAL_DATA') }}</p>
            </div>
            <div class="col-sm-4">
                <button class="app-btn app-btn--small app-btn-default pull-right" @click="onManage">
                    {{ $t('MANAGE') }}
                </button>
                <button class="app-btn app-btn--small app-btn-primary pull-right" @click="onAdd">
                    {{ $t('ADD') }}
                </button>
            </div>
        </div>

        <div v-if="addData" class="data-details">
            <div class="row">
                <div class="col-xs-12">
                    <p>{{ $t('ADD_MEDICAL_DATA_INFO') }}</p>
                    <h4>{{ $t('ADD_MEDICAL_DATA') }}</h4>
                    <div class="row mt-4 row-flex-align-bottom ">
                        <div class="col-xs-12 col-sm-6 col-md-3 is-relative form-group">
                            <el-date-picker
                                id="datePicker"
                                v-model="dateFrom"
                                type="date"
                                :placeholder="$t('EXAMINATION_DATE')"
                                :class="{ 'invalid-date': !dateIsValid && formSubmitted }"
                            >
                            </el-date-picker>
                            <label for="datePicker" class="d-inline">
                                <img class="date-icon" src="../../../assets/images/icons/ico-calendar.png" />
                            </label>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-3 form-group">
                            <el-select
                                v-model="value1"
                                :placeholder="$t('EXAMINATION_TYPE')"
                                :class="{ 'invalid-date': !typeIsValid && formSubmitted }"
                            >
                                <el-option
                                    v-for="item in select1"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-3 form-group">
                            <el-select
                                v-model="value2"
                                :placeholder="$t('BIRADS')"
                                :class="{ 'invalid-date': !biradsIsValid && formSubmitted }"
                            >
                                <el-option
                                    v-for="item in select2"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-3 form-group">
                            <div class="info__box box-shadow">
                                {{ $t('BIRADS_INFO') }}
                            </div>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xs-12">
                            <el-input
                                type="textarea"
                                :rows="3"
                                :placeholder="$t('ADDITIONAL_COMMENTS')"
                                v-model="textarea"
                                :class="{ 'invalid-date': !commentIsValid && formSubmitted }"
                            >
                            </el-input>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 text-right mt-3">
                    <button class="app-btn app-btn--small app-btn-primary pull-right" @click="onAddItem">
                        {{ $t('ADD') }}
                    </button>
                    <button class="app-btn app-btn--small app-btn-default pull-right" @click="resetDetails">
                        {{ $t('CANCEL') }}
                    </button>
                </div>
            </div>
        </div>

        <div v-if="manageData" class="data-details">
            <div class="row">
                <div class="col-xs-12">
                    <p>{{ $t('MANAGE_ADDITIONAL_DATA') }}</p>
                    <el-table :data="tableData1" style="width: 100%; margin-top: 20px">
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <p class="text-break">{{ `${$t('EXAMINATION_DATE')}: ${props.row.date}` }}</p>
                                <p class="text-break">{{ `${$t('EXAMINATION_TYPE')}: ${props.row.name}` }}</p>
                                <p class="text-break">
                                    {{ `${$t('BIRADS')}: ${props.row.type === 'NONE' ? $t('NONE') : props.row.type}` }}
                                </p>
                                <p class="text-break">{{ `${$t('COMMENT')} ${props.row.description}` }}</p>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="$t('DELETE_CHOSEN_MEDICAL_DATA')"
                                    placement="top"
                                >
                                    <el-button
                                        @click.native.prevent="deleteRow(props.$index, tableData1)"
                                        type="text"
                                        class="app-btn app-btn-default ml-0"
                                        size="small"
                                    >
                                        {{ $t('DELETE') }}
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="$t('EDIT_CHOSEN_MEDICAL_DATA')"
                                    placement="top"
                                >
                                    <el-button
                                        @click.native.prevent="editRow(props.$index, tableData1)"
                                        type="text"
                                        class="app-btn app-btn-default"
                                        size="small"
                                    >
                                        {{ $t('EDIT') }}
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="date" :label="$t('EXAMINATION_DATE')"></el-table-column>
                        <el-table-column :label="$t('EXAMINATION_TYPE')">
                            <template slot-scope="props">
                                <p>{{ $t(props.row.name) }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="!clientWidthIsSmall" :label="$t('BIRADS')">
                            <template slot-scope="props">
                                <p>{{ props.row.type === 'NONE' ? $t('NONE') : props.row.type }}</p>
                            </template>
                        </el-table-column>
                        <el-table-column v-if="!clientWidthIsSmall" width="220px">
                            <template slot-scope="scope">
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="$t('DELETE_CHOSEN_MEDICAL_DATA')"
                                    placement="top"
                                >
                                    <el-button
                                        @click.native.prevent="deleteRow(scope.$index, tableData1)"
                                        type="text"
                                        class="app-btn app-btn-default"
                                        size="small"
                                    >
                                        {{ $t('DELETE') }}
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip
                                    class="item"
                                    effect="dark"
                                    :content="$t('EDIT_CHOSEN_MEDICAL_DATA')"
                                    placement="top"
                                >
                                    <el-button
                                        @click.native.prevent="editRow(scope.$index, tableData1)"
                                        type="text"
                                        class="app-btn app-btn-default"
                                        size="small"
                                    >
                                        {{ $t('EDIT') }}
                                    </el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="col-xs-12 text-right mt-3">
                    <button class="app-btn app-btn--small app-btn-primary pull-right" @click="onAdd">
                        {{ $t('ADD') }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMedicalData } from './../../../main';
import { clientWidthIsSmallMixin } from '../../../assets/js/mixins';

export default {
    mixins: [clientWidthIsSmallMixin],
    data() {
        return {
            currentEdit: -1,
            infoData: true,
            addData: false,
            manageData: false,
            dateFrom: '',
            value1: '',
            value2: '',
            textarea: '',
            select1: [
                {
                    value: 'USG',
                    label: this.$t('USG'),
                },
                {
                    value: 'MAMMOGRAPHY',
                    label: this.$t('MAMMOGRAPHY'),
                },
                {
                    value: 'MRI',
                    label: this.$t('MRI'),
                },
                {
                    value: 'ELASTOGRAPHY',
                    label: this.$t('ELASTOGRAPHY'),
                },
            ],
            select2: [
                {
                    value: '0',
                    label: '0',
                },
                {
                    value: '1',
                    label: '1',
                },
                {
                    value: '2',
                    label: '2',
                },
                {
                    value: '3',
                    label: '3',
                },
                {
                    value: '4',
                    label: '4',
                },
                {
                    value: '4a',
                    label: '4a',
                },
                {
                    value: '4b',
                    label: '4b',
                },
                {
                    value: '4c',
                    label: '4c',
                },
                {
                    value: '5',
                    label: '5',
                },
                {
                    value: '6',
                    label: '6',
                },
                {
                    value: 'NONE',
                    label: this.$t('NONE'),
                },
            ],
            tableData1: this.$store.state.survey.survey.additionalData,
            formSubmitted: false,
        };
    },
    methods: {
        onAdd() {
            this.addData = true;
            this.infoData = false;
            this.manageData = false;
            this.dateFrom = '';
            this.value1 = '';
            this.value2 = '';
            this.textarea = '';
            this.currentEdit = -1;
        },
        onAddItem() {
            this.formSubmitted = true;

            if (this.itemIsValid) {
                let item = {
                    date: this.$moment(this.dateFrom).format('YYYY-MM-DD'),
                    name: this.value1,
                    type: this.value2,
                    description: this.textarea,
                };

                if (this.currentEdit === -1) {
                    this.tableData1.push(item);
                } else {
                    this.tableData1[this.currentEdit] = item;
                }

                this.$store.commit('STATE_SURVEY', {
                    additionalData: this.tableData1,
                });
                mapMedicalData();
                this.$http.post('/openehr/api/composition/', this.$store.state.medicalData).then(() => {
                    this.addData = false;
                    this.infoData = true;
                    this.manageData = false;
                    this.formSubmitted = false;
                });
            }
        },
        onManage() {
            this.manageData = true;
            this.addData = false;
            this.infoData = false;
        },
        deleteRow(index, rows) {
            rows.splice(index, 1);
            this.$store.commit('STATE_SURVEY', {
                additionalData: this.tableData1,
            });
            mapMedicalData();
            this.$http.post('/openehr/api/composition/', this.$store.state.medicalData);
        },

        editRow(index, rows) {
            this.addData = true;
            this.infoData = false;
            this.manageData = false;

            this.dateFrom = Date.parse(rows[index].date);
            this.value1 = rows[index].name;
            this.value2 = rows[index].type;
            this.textarea = rows[index].description;

            this.currentEdit = index;
        },
        resetDetails() {
            this.formSubmitted = false;
            this.dateFrom = '';
            this.value1 = '';
            this.value2 = '';
            this.textarea = '';
            this.addData = false;
            this.infoData = true;
            this.manageData = false;
        },
    },
    computed: {
        typeIsValid() {
            return this.value1 !== '';
        },
        biradsIsValid() {
            return this.value2 !== '';
        },
        commentIsValid() {
            return this.textarea !== '';
        },
        dateIsValid() {
            const today = this.$moment();
            const examinationDate = this.$moment(this.dateFrom);
            return examinationDate.isBefore(today);
        },
        itemIsValid() {
            return this.typeIsValid && this.biradsIsValid && this.commentIsValid && this.dateIsValid;
        },
    },
};
</script>

<style lang="css" scoped>
.el-date-editor .el-input {
    width: 100%;
}

.el-date-editor.el-input input {
    width: 100%;
}

input {
    width: 100%;
    background-color: red !important;
}

button {
    margin-left: 10px;
    height: 40px;
}

h4 {
    font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// additional-document.vue?3673a88f